module.exports = __webpack_public_path__ + "static/media/login icon.b36324e9.svg";